module.exports = __webpack_public_path__ + "static/media/ICONO-CARPETA-1.9f00a6bf.png";